import React, { Component } from "react";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { getSellsByMonth } from "../../../../store/dashboard/actions";
import { Bar } from "react-chartjs-2";
import * as charts from "./_charts";
import {
  selectorChart,
  formatHelper,
  selectHelper,
} from "../../../../common/helpers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Card,
  CardHeader,
  CardBody,
  Collapse,
  Row,
  Col,
  Label,
  Alert,
  Button,
} from "reactstrap";
import Select from "react-select";
import { ExportCSV } from "../../../../components";
import { getSellsByMonth as salesByDayExport } from "../../../../service/dashboard";
import { roles, messages, layout } from "../../../../common/constants";
import { getStores } from "../../../../store/store/actions";
import { selectUserRole } from "../../../../store/user/selector";
import { selectStoresForSelect } from "../../../../store/store/selector";
import { exportExcel } from "./excel";

class CardSellsByMonth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSellsByMonth: true,
      selectedYear: null,
      showChart: false,
      loadingExport: false,
      selectedStore: null,
    };
    this.handleObtainSalesExport = this.handleObtainSalesExport.bind(this);

    this.handleStoreChange = this.handleStoreChange.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);
  }

  async handleStoreChange(value, reset = false) {
    if (value == this.state.selectedStore) return;
    await this.setState({ selectedStore: value, page: 1 });

    if (!this.state.selectedYear) return;
    this.props.getSellsByMonth({
      year: this.state.selectedYear.value,
      store: this.state.selectedStore.value,
      reset,
    });
  }

  async componentDidMount() {
    await this.props.getStores({ reset: true });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
    }
  }

  async handleYearChange(value, reset = false) {
    await this.setState({
      selectedYear: value,
      showChart: true,
    });

    if (!this.state.selectedYear) return;
    this.props.getSellsByMonth({
      year: this.state.selectedYear.value,
      store: this.state.selectedStore.value,
      reset,
    });
  }

  async handleObtainSalesExport() {
    this.setState({ loadingExport: true });
    const { selectedYear, selectedStore } = this.state;
    salesByDayExport(selectedYear.value, selectedStore.value).then(
      (response) => {
        exportExcel(response.data.data, selectedStore, selectedYear);
        this.setState({ loadingExport: false });
      }
    );
  }

  render() {
    return (
      <Card>
        <CardHeader
          onClick={() =>
            this.setState({ showSellsByMonth: !this.state.showSellsByMonth })
          }
        >
          Ventas Mes - Año
        </CardHeader>
        <Collapse isOpen={this.state.showSellsByMonth}>
          <CardBody>
            <Row>
              <Col md="4">
                <Row>
                  <Col sm="4">
                    <Label className="mt-2">AÑO:</Label>
                  </Col>
                  <Col sm="8">
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isSearchable={true}
                      noOptionsMessage={() => {
                        return messages.SELECT_NO_OPTIONS;
                      }}
                      placeholder="AÑO"
                      options={this.props.years}
                      loadingMessage={() => {
                        return messages.SELECT_LOADING;
                      }}
                      onChange={this.handleYearChange}
                      value={this.state.selectedYear}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md="5">
                {(this.props.role == roles.SUPER_ADMIN ||
                  this.props.role == roles.ADMIN) && (
                  <Row>
                    <Col sm="4">
                      <Label className="mt-2">TIENDA:</Label>
                    </Col>

                    <Col sm="8">
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        isLoading={this.props.loadingStores}
                        isSearchable={true}
                        noOptionsMessage={() => {
                          return messages.SELECT_NO_OPTIONS;
                        }}
                        placeholder=""
                        options={this.props.stores}
                        loadingMessage={() => {
                          return messages.SELECT_LOADING;
                        }}
                        onChange={this.handleStoreChange}
                        value={this.state.selectedStore}
                        isDisabled={this.props.loadingStores}
                      />
                    </Col>
                  </Row>
                )}
              </Col>
              <Col md="3">
                {this.state.selectedYear ? (
                  <ExportCSV
                    disabled={this.state.loadingExport}
                    exportCSV={this.handleObtainSalesExport}
                    minWidth={layout.SM_MIN_WIDTH}
                  />
                ) : null}
              </Col>
            </Row>
            <hr className="my-4" />
            {this.state.showChart ? (
              <Row>
                <Col>
                  <Bar
                    data={charts.SellsByMonthData(
                      this.props.sellsByMonthChartData
                    )}
                    options={charts.SellsByMonthOptions()}
                  />
                </Col>
              </Row>
            ) : (
              <Row>
                <Col>
                  <Alert color="info">Seleccione un año</Alert>
                </Col>
              </Row>
            )}
          </CardBody>
        </Collapse>
      </Card>
    );
  }
}

function mapStateToProps(state) {
  const { sellsByMonth, total, error, loading } =
    state.dashboard.sellsByMonthList;
  return {
    error,
    loading,
    years: selectHelper.getYearsForSelect(),
    sellsByMonthChartData: selectorChart.selectChartData(
      sellsByMonth,
      "month",
      "total",
      formatHelper.toTwoDecimal,
      total
    ),
    role: selectUserRole(state),
    stores: selectStoresForSelect(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getSellsByMonth,
      getStores,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CardSellsByMonth);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardSellsByMonth/CardSellsByMonth.js